import React, { FC } from 'react';

import * as Styled from './ProjectsCountLabel.styles';

interface ProjectsCountLabelProps {
  count: number;
}

export const ProjectsCountLabel: FC<ProjectsCountLabelProps> = (props) => {
  const { count } = props;

  return <Styled.Root>{count}</Styled.Root>;
};
